export default __webpack_public_path__ + "static/tablet-home-map-static-img-b343f5aaa17756ca31351730315237d7.jpg";